import { ApplicationInformation, BorrowerInformation } from 'api/rtkQueryApi';
import { BaseApplicationKeyInformationType } from 'handlers/application';
import { useEffect, useState } from 'react';
import { useApplicationData } from 'utils/useApplicationData';

const getCreditScoreDisclosureData = ({
  application,
  borrower,
}: {
  application: ApplicationInformation['application'];
  borrower: BorrowerInformation['borrower'];
}) => {
  if (!application || !borrower) {
    return null;
  }

  const { variables } = application;

  const completeDate = variables[BaseApplicationKeyInformationType.FinalCreditUnderwritingCompleteDate];
  const score = variables[BaseApplicationKeyInformationType.EquifaxFICOScore];

  return {
    score,
    completeDate: completeDate && new Date(completeDate),
    name: `${borrower.firstName} ${borrower.lastName}`,
  };
};

export const useCreditScoreDisclosureData = () => {
  const { borrower, application, applicationLoading, borrowerLoading } = useApplicationData();
  const [creditScoreDisclosureData, setCreditScoreDisclosureData] = useState<{
    score: any;
    completeDate: any;
    name: string;
  } | null>(null);

  useEffect(() => {
    if (borrower && application) {
      setCreditScoreDisclosureData(
        getCreditScoreDisclosureData({
          application,
          borrower,
        }),
      );
    }
  }, [borrower, application]);

  return { applicationLoading, borrowerLoading, creditScoreDisclosureData };
};
